module.exports = __webpack_public_path__ + "static/Nudista-Bold-d6743744ee6f9dc4474c2cf53389dcaf.ttf";